import React, { Component } from "react";
import report1 from "../assets/report1.svg";
import report2 from "../assets/report2.svg";
import report3 from "../assets/report3.svg";
import report4 from "../assets/report4.svg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default class EditButton extends Component {
  // componentDidUpdate() {
  //     ReactTooltip.rebuild()
  // }

  render() {
    return (
      <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 200, hide: 200 }}
          overlay={
            <Tooltip style={{ fontFamily: "SFUIDisplay", fontSize: "12px" }}>
              اعتبارهای دريافتی مشترک
            </Tooltip>
          }
        >
          <div
            style={{ cursor: "pointer", userSelect: "none" }}
            onClick={() => this.props.GetCreditsOfAccount(this.props.value, 1)}
          >
            <img
              src={report1}
              alt=""
              style={{ objectFit: "contain", height: "25px" }}
            />
          </div>
        </OverlayTrigger>
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 200, hide: 200 }}
          overlay={
            <Tooltip style={{ fontFamily: "SFUIDisplay", fontSize: "12px" }}>
              ليست خريدهای مشترک
            </Tooltip>
          }
        >
          <div
            style={{
              cursor: "pointer",
              userSelect: "none",
              marginRight: "15px",
            }}
            onClick={() => this.props.GetInvoicesOfAccount(this.props.value, 1)}
          >
            <img
              src={report2}
              alt=""
              style={{ objectFit: "contain", height: "25px" }}
            />
          </div>
        </OverlayTrigger>
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 200, hide: 200 }}
          overlay={
            <Tooltip style={{ fontFamily: "SFUIDisplay", fontSize: "12px" }}>
              پيام‌های ارسالی
            </Tooltip>
          }
        >
          <div
            style={{
              cursor: "pointer",
              userSelect: "none",
              marginRight: "15px",
            }}
            onClick={() => this.props.GetSMSesOfAccount(this.props.value, 1)}
          >
            <img
              src={report3}
              alt=""
              style={{ objectFit: "contain", height: "25px" }}
            />
          </div>
        </OverlayTrigger>
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 200, hide: 200 }}
          overlay={
            <Tooltip style={{ fontFamily: "SFUIDisplay", fontSize: "12px" }}>
              گزارش استفاده از اعتبار مشترک
            </Tooltip>
          }
        >
          <div
            style={{
              cursor: "pointer",
              userSelect: "none",
              marginRight: "15px",
            }}
            onClick={() =>
              this.props.GetDiscountHistoryOfAccount(this.props.value, 1)
            }
          >
            <img
              src={report4}
              alt=""
              style={{ objectFit: "contain", height: "25px" }}
            />
          </div>
        </OverlayTrigger>
      </div>
    );
  }
}
